var _circle, _ellipse, _path, _path2, _path3, _path4, _path5, _circle2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrowserUnsupported(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 1,
    cx: 8,
    cy: 8,
    r: 7,
    stroke: "currentColor"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 1,
    cx: 7.99998,
    cy: 8,
    rx: 3.88921,
    ry: 7,
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1,
    d: "M1 8H15",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1,
    d: "M8 15L8 1",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1,
    d: "M3 3C4.26254 4.23719 5.99168 5 7.89898 5C9.80629 5 11.5354 4.23719 12.798 3",
    stroke: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1,
    d: "M3 13C4.26254 11.7628 5.99168 11 7.89898 11C9.80629 11 11.5354 11.7628 12.798 13",
    stroke: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M9.91546 7.91174C10.3714 7.08281 11.5625 7.08281 12.0184 7.91174L15.4889 14.2217C15.9287 15.0214 15.3501 16 14.4374 16H7.49644C6.58372 16 6.00513 15.0214 6.44499 14.2217L9.91546 7.91174Z",
    fill: "#EB5757"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 0,
    cx: 10.9669,
    cy: 14.5,
    r: 0.5,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 0,
    x: 10.4669,
    y: 10,
    width: 1,
    height: 3,
    rx: 0.5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowserUnsupported);
export default __webpack_public_path__ + "static/media/browser-unsupported.293b8a8a2f14ac501d7e5962f914d034.svg";
export { ForwardRef as ReactComponent };